import MemberManager from '../manager';
import {
  forgotPassword,
  updateProfile,
  updatePassword,
  getAllOrganizations,
  getAllApplications,
  disableAccount,
} from '../slices';
import { takeLatestRequestHandler } from '@madbox/react_redux_request_handling';

const handlers = {
  /**
   * @param {string} mail
   */
  forgotPassword: {
    ...forgotPassword,
    method: (action) => MemberManager.forgotPassword(action.payload),
  },
  /**
   * @param {string} mail
   * @param {string} firstname
   * @param {string} lastname
   * @param {File} profilePicture
   * @param {string} spokenLanguages - 'fr,es,en'
   */
  updateProfile: {
    ...updateProfile,
    method: (action) =>
      MemberManager.updateProfile(
        action.payload.mail,
        action.payload.firstname,
        action.payload.lastname,
        action.payload.profilePicture,
        action.payload.spokenLanguages
      ),
    options: {
      successMessage: 'Profile was updated!',
    },
  },
  /**
   * @param {string} oldPassword
   * @param {string} newPassword
   */
  updatePassword: {
    ...updatePassword,
    method: (action) => MemberManager.updatePassword(action.payload.oldPassword, action.payload.newPassword),
    options: {
      errorTransformer(error) {
        return error.errors;
      },
    },
  },
  /**
   * @param {string} memberId
   */
  getAllOrganizations: {
    ...getAllOrganizations,
    method: (action) => MemberManager.Organization.getAll(action.payload),
  },
  /**
   * @param {string} orgSlug
   */
  getAllApplications: {
    ...getAllApplications,
    method: (action) => MemberManager.Application.getAll(action.payload),
  },
  /**
   * @param {string} memberId
   * @param {boolean} isDisabled
   * @param {string[]} servicesToRemove (Required only if isDisabled === true)
   */
  disableAccount: {
    ...disableAccount,
    method: (action) => {
      MemberManager.disableAccount(action.payload.memberId, action.payload.isDisabled);
      if (action.payload.isDisabled) {
        window.location.href = `#/members/${action.payload.memberId}/remove?servicesToRemove=${action.payload.servicesToRemove}`;
      }
      return {
        memberId: action.payload.memberId,
        isDisabled: action.payload.isDisabled,
      };
    },
  },
};

export default function* saga() {
  yield takeLatestRequestHandler(handlers.forgotPassword);
  yield takeLatestRequestHandler(handlers.updatePassword);
  yield takeLatestRequestHandler(handlers.updateProfile);
  yield takeLatestRequestHandler(handlers.getAllOrganizations);
  yield takeLatestRequestHandler(handlers.getAllApplications);
  yield takeLatestRequestHandler(handlers.disableAccount);
}
